import React from 'react'

/* global API */

const LogoutRoute = () => {
    React.useEffect(() => {
        API.instance().logout()
        window.location.href = '/'
    }, [])

    return (
        <div className="page logout-page" />
    )
}

export default LogoutRoute
